import { render } from "./FaqFeedbackActions.vue?vue&type=template&id=56d04d03"
import script from "./FaqFeedbackActions.vue?vue&type=script&lang=js"
export * from "./FaqFeedbackActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__